export default __webpack_public_path__ + "static/media/ico-aws-red-shift-circle-solid.ac0607ef.svg";